var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottom4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 0C13.4777 0 14 0.559644 14 1.25V8.75C14 9.39728 13.5408 9.92937 12.9524 9.99329L12.8333 10H1.16667L1.04761 9.99329C0.459213 9.92937 0 9.39728 0 8.75V1.25C0 0.559644 0.522334 2.0133e-08 1.16667 0H12.8333ZM1.16667 8.75H12.8333V3.75H1.16667V8.75ZM3.5 5C4.14433 5 4.66667 5.55964 4.66667 6.25C4.66667 6.94036 4.14433 7.5 3.5 7.5C2.85567 7.5 2.33333 6.94036 2.33333 6.25C2.33333 5.55964 2.85567 5 3.5 5ZM1.16667 2.5H12.8333V1.25H1.16667V2.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom4);
export default __webpack_public_path__ + "static/media/bottom4.bd8e6cdc6dcbe51d39a8c25a52a38645.svg";
export { ForwardRef as ReactComponent };